import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PatchCulpritPartTwoVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartTwoVehicleInformation/patchCulpritPartTwoVehicleInformation.type';
import { patchCulpritPartTwoVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartTwoVehicleInformation/patchCulpritPartTwoVehicleInformationFunction';

export const patchCulpritPartTwoVehicleInformationOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchCulpritPartTwoVehicleInformationType
> => ({
  mutationKey: ['patch-culprit-part_two-vehicle-information'],
  mutationFn: ({ id, data }: PatchCulpritPartTwoVehicleInformationType) =>
    patchCulpritPartTwoVehicleInformationFunction({ data, id }),
});
